import React from "react";
import ThemedDropdown from "components/common/DropDown/ThemedDropdown";
import { HiOutlineFunnel } from "react-icons/hi2";

const TimesheetStatusSelect = ({
  options = [],
  selectedValue,
  onChange,
  placeholder = "All statuses",
}) => (
  <ThemedDropdown
    value={selectedValue}
    options={options}
    placeholder={placeholder}
    onChange={(_value, option) => onChange?.(option)}
    widthClass="w-full"
    textClass="text-[13px] font-medium"
    leadingIcon={
      <HiOutlineFunnel className="h-4 w-4 shrink-0 text-[#64748B]" aria-hidden />
    }
  />
);

export default TimesheetStatusSelect;
